<div class="user-select-none">
    <div class="container">
        <div class="d-flex flex-wrap justify-content-center">
            @for (customer of searchedCustomers; track customer.id) {
                <div class="col-sm-12 col-lg-8 col-24 p-2">
                    <button
                        (click)="openCustomer(customer)"
                        class="w-100 customer-button"
                        color="primary"
                        mat-stroked-button>
                        {{ customer.name }}
                    </button>
                </div>
            }
        </div>

        <div #tooltip="matTooltip" matTooltip="Druk op enter om dit gebied te openen" matTooltipPosition="below"></div>
    </div>
</div>

<ng-template #sortSearchTemplate>
    <button
        (click)="toggleCustomerSorting()"
        [attr.aria-pressed]="sortAlphabetically"
        mat-stroked-button
        [matTooltip]="sortAlphabetically ? 'Sorteer recent gebruikt' : 'Sorteer alfabetisch'"
        type="button">
        {{ sortAlphabetically ? 'Recent' : 'A-Z' }}
    </button>
</ng-template>
